import _ from 'lodash';

export const getLandingPageName = state =>
  _.get(state, ['router', 'current', 'landingPageName']);

export const getCurrentReferrer = state =>
  _.get(state, ['router', 'current', 'query', 'referrer'], '');
